<template>

  <div class="mt-4">
    <div class="row">
      <div class="col-md-12">
        <b-card class="mt-2 mb-4 shadow-sm">
          <b-form v-unsave-detector @submit.stop.prevent="clickOnValidateBtn">
            <div class="row">
              <div class="col-md-6">
                <label
                  class="font-weight-bolder secondary-color h6">{{
                    $t('operation.dossier.menu2') + ' ' + $t('de') + ' ' + $t('l.i') + $t('entreprise')
                  }} </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="mb-3">{{ $t('operation.dossier.step2.subtitle') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex mb-2">
                  <span class="medium-text mr-2"> {{ $t('operation.dossier.field.text') }}</span>
                  <span class="italic-text"> {{ $t('operation.dossier.field.max.length') }}</span>
                </div>
                <b-form-textarea
                  id="texte-explicatif-input"
                  v-model="form.texte.value"
                  :state="form.texte.state"
                  maxlength="250"
                  type="text"
                  v-on:change="emitChangeValue">
                </b-form-textarea>
              </div>
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.organigramme.invalidFeedback"
                  class="medium-label mb-4">
                  <div class="d-flex">
                    <label for="organigramme-input">
                      {{ $t('Image.organigramme') }}
                    </label>
                  </div>
                  <custom-form-file
                    id="organigramme-input"
                    v-model="form.organigramme.value"
                    :drop-placeholder="$t('drop-placeholder')"
                    :placeholder="form.organigramme.value"
                    accept=".png, .jpeg, .jpg"
                    @preview="imagePreview = $event"
                  />
                  <div>
                    <img v-if="imagePreview" :src="imagePreview" alt="Image preview" class="mt-1 preview-image"/>
                    <img v-else-if="!imagePreview && this.situation.organigramme"
                         :src="getFileUrl(this.situation.organigramme.fileUrl)" alt="Image preview"
                         class="mt-1 preview-image"/>
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary">{{ $t('Save.and.Continue') }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../../../services/api'
import CustomFormFile from "../../../components/b122/editFields/CustomFormFile.vue";

export default {
  name: "DossierOperationSituation",
  components: {CustomFormFile},

  props: {
    situationCreationDone: Boolean,
    dossierId: Number,
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      situation: {},
      form: {
        texte:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        organigramme:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          }
      },
      imagePreview: null,
    }
  },
  emits: ['didContinueSituation', 'didBack', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
  },
  methods: {

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    async fetchData() {
      if (this.dossierId && this.situationCreationDone) {
        await this.fetchSituation()
        this.setInitialValues()
      }
    },

    async fetchSituation() {
      await api
        .get(`/situation/getSituationByDossier/${this.dossierId}`)
        .then(response => {
          this.situation = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    setInitialValues() {
      if (this.dossierId != null) {
        if (this.situation.structure && this.situation.structure !== 'null') {
          this.form.texte.value = this.situation.structure
        }
        this.form.organigramme.value = this.situation.organigramme.filename
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    /** Bouton validate (Etape suivante)
     *  save + redirection vers l'étape 2 de la création d'operation + success toast
     */
    clickOnValidateBtn() {
      this._save(response => {
        this.$emit('didContinueSituation', response.data.id)
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.form.texte.value, 'f.added')
        })
      })
    },


    /** Enregistrement des infos de l'operation en db
     *  POST si l'operation n'existe pas - PUT si c'est une modification (type d'operation non modifiable)
     * @param onSuccessClosure (effectuée si l'enregistrement en db fonctionne)
     */
    _save(onSuccessClosure) {
      let data = new FormData()
      data.append('dossierId', this.dossierId)
      data.append('texte', this.form.texte.value)
      data.append('organigramme', this.form.organigramme.value)

      api({
        method: this.situation.id ? 'PUT' : 'POST',
        url: this.situation.id ? `situation/${this.situation.id}` : 'situation',
        data: data
      })
        .then((response) => {
          if (onSuccessClosure) onSuccessClosure(response)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {

            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    /** Success toast quand l'operation est créée/modifiée
     */
    successToast(operationName, actionName) {
      this.$bvToast.toast("Situation opération" + this.$i18n.t(actionName), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationDossier/dossierOperationCreateSteps/DossierOperationSituation.vue